import { useFormik } from 'formik';
import type { TFunction } from 'i18next';

import { errorToastMessage } from '../../../../components/layout/toast-root/toast';
import { useFirebaseAuth } from '../../../../hooks/useFirebaseAuth';
import { handleAuthError } from '../../../../utils/auth/auth-errors';
import { getResetPasswordFormValidation } from './FormikData';

export function useResetPasswordPage(
  t: TFunction,
  oobCode: string,
  afterResetPassword: () => void,
) {
  const { confirmPasswordReset } = useFirebaseAuth();

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getResetPasswordFormValidation(t),
    initialValues: { password: '', confirmPassword: '' },
    onSubmit: submit,
  });

  async function submit(values: { password: string }) {
    try {
      if (oobCode) {
        await confirmPasswordReset(oobCode, values.password);
        afterResetPassword();
      } else {
        errorToastMessage(t('resetPassword.errorResetPasswordMessage'));
      }
    } catch (error: unknown) {
      console.error('Reset password error: ', error);
      handleAuthError(error, t);
    }
  }

  return { formik };
}
